/** @format */

import React, { useEffect, useState } from 'react';
import './App.scss';
import Registration from './pages/auth/Registration';
import {
    BrowserRouter as Router,
    Route,
    Routes,
    useLocation,
} from 'react-router-dom';
// import Dashboard from './pages/dashboard/Dashboard';
import RequestMainPage from './pages/certificate-request/RequestMainPage';
import Dashboard from './pages/dashboard/index';
// import CertificateRequest from './pages/certificate-request/index';
import LeftDrawer from './components/sidebar/LeftDrawer';
import { Box } from '@mui/material';
import TopRightPanel from './components/header/TopRightPanel';
import MyProfile from './components/header/MyProfile';
import Help from './components/header/Help';
import Header from './components/header/Header';
import TradersList from './pages/maintenance/TradersList';
import FrontComponent from './pages/auth/index';
import { AppDispatch, store } from './redux/store';
import { Provider, useDispatch } from 'react-redux';
// import './assets/scss/global.scss';
// import { truncate } from 'fs';
import Authorization from './utils/authorization';
import { ToastContainer } from 'react-toastify';

// MSAL imports
import {
    PublicClientApplication,
    EventType,
    EventMessage,
    AuthenticationResult,
} from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './pages/auth/authConfig';
import { getLocalStorageData } from './utils/useLocalStorage';
import NotificationPanel from './components/header/NotificationPanel';
import { getNotificationList } from './redux/actions/common/NotificationListAction';
import { CaseRequest } from './pages/case-creation/CaseRequest';
import CaseListView from './pages/case-creation/CaseListView';
import { Alert } from './utils/toastr';
import { saveOrUpdateRequest } from './services/apiUtils';
import Loader from './components/reusableComp/Loader';

export const msalInstance = new PublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        msalInstance.setActiveAccount(account);
    }
});

function App(): JSX.Element {
    const [isUserLoggedIn, setLoggedIn] = useState<boolean>(false);
    const [userRole, setUserRole] = useState<string | null>(null);
    const [externalLoginState, setExternalLoginState] = useState(true);
    const [openNotifications, setOpenNotifications] = useState(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch<AppDispatch>();
    const location = useLocation();
    const pageName = location.pathname.slice(1).toLowerCase();

    const externalLoginStatus = (value: boolean) => {
        setExternalLoginState(value);
    };

    useEffect(() => {
        let mounted = true;
        const checkSessionAndFetchDetails = async () => {
            try {
                await Authorization.doAuth();
                if (Authorization.isLoggedIn()) {
                    const userObj = Authorization.getAuthUser();
                    if (mounted) {
                        setLoggedIn(true);
                        setUserRole(userObj?.role);
                    }
                    console.log('userObj in App useEffect', userObj);
                    dispatch(
                        getNotificationList({
                            role: userObj?.role,
                            sfid: userObj?.sfid,
                        })
                    );
                } else {
                    if (mounted) {
                        setLoggedIn(false);
                        setUserRole(null);
                    }
                    console.log(
                        'error : Authorization failed. Please login again.'
                    );
                }
            } catch (error: any) {
                if (mounted) {
                    setLoggedIn(false);
                    setUserRole(null);
                }
                console.log(
                    'error : Authorization failed. Please login again.'
                );
            } finally {
                if (mounted) {
                    setLoading(false);
                }
            }
        };
        checkSessionAndFetchDetails();
        return () => {
            mounted = false;
        };
    }, [location]);

    const toggleNotiPanel = () => setOpenNotifications(!openNotifications);
    const toggleLeftdrawer = () => setOpenDrawer(!openDrawer);

    let ele;
    if (userRole === 'APPROVALMANAGER') {
        ele = <Dashboard />;
    } else if (userRole === 'SUPPORTADMIN') {
        ele = <CaseListView />;
    } else if (userRole === 'TRADER') {
        ele = <RequestMainPage />;
    }
    if (loading) {
        return <Loader />;
    }
    return (
        <div className='App'>
            <MsalProvider instance={msalInstance}>
                <ToastContainer />
                {loading && <Loader />}
                {isUserLoggedIn && userRole ? (
                    <>
                        <LeftDrawer
                            page={pageName}
                            setLoggedIn={setLoggedIn}
                            onExternalLoginStatus={externalLoginStatus}
                            toggleLeftdrawer={toggleLeftdrawer}
                            openDrawer={openDrawer}
                            onClick={toggleLeftdrawer}
                        />
                        <Box sx={{ width: '100%', height: '8vh' }}>
                            <TopRightPanel toggleNotiPanel={toggleNotiPanel} />
                        </Box>
                        {openNotifications && (
                            <NotificationPanel
                                openNotifications={openNotifications}
                                toggleNotiPanel={toggleNotiPanel}
                            />
                        )}
                    </>
                ) : (
                    <Header
                        type={pageName}
                        externalLoginState={externalLoginState}
                    />
                )}
                <Routes>
                    {isUserLoggedIn ? (
                        <>
                            <Route path='/' element={ele} />
                            <Route
                                path='/dashboard'
                                element={
                                    userRole === 'APPROVALMANAGER' ? (
                                        <Dashboard />
                                    ) : null
                                }
                            />
                            <Route path='/myProfile' element={<MyProfile />} />
                            <Route path='/help' element={<Help />} />
                            <Route
                                path='/requests'
                                element={
                                    (userRole === 'APPROVALMANAGER' ||
                                        userRole === 'TRADER') && (
                                        <RequestMainPage />
                                    )
                                }
                            />
                            <Route
                                path='/caserequest'
                                element={<CaseListView />}
                            />
                            <Route
                                path='/traders-list'
                                element={
                                    userRole === 'APPROVALMANAGER' && (
                                        <TradersList />
                                    )
                                }
                            />
                        </>
                    ) : (
                        <>
                            <Route
                                path='/*'
                                element={
                                    <FrontComponent
                                        setLoggedIn={setLoggedIn}
                                        onExternalLogin={externalLoginStatus}
                                    />
                                }
                            />
                            <Route
                                path='/register'
                                element={
                                    <Registration setLoggedIn={setLoggedIn} />
                                }
                            />
                            <Route
                                path='/login'
                                element={
                                    <FrontComponent
                                        setLoggedIn={setLoggedIn}
                                        onExternalLogin={externalLoginStatus}
                                    />
                                }
                            />
                        </>
                    )}
                </Routes>
            </MsalProvider>
        </div>
    );
}

export default App;
